import { useWorkspace } from '@/features/workspaces/hooks';
import { BaseAudience } from '@/models/audiences';
import { useGetEstimateQuery } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { IconButton } from '@/lib';
import { Loadable } from '@/components/loaders';

import LinkExternalIcon from '@/assets/icons/link-external.svg?react';

type DependencyAudienceTotalUsersColumnProps = {
  audienceId: BaseAudience['id'];
};

export const DependencyAudienceTotalUsersColumn: FC<DependencyAudienceTotalUsersColumnProps> = ({ audienceId }) => {
  const onAudienceClick = () => {
    window.open(`/audiences/${audienceId}`, '_blank');
  };

  const workspace = useWorkspace();

  const { data, isLoading } = useGetEstimateQuery({
    workspaceId: workspace.id,
    audienceId,
  });

  return (
    <>
      <Loadable spinnerClassName='size-3' isLoading={isLoading}>
        <p className='grow text-xs font-semibold text-primary-900'>{data?.size || 0}</p>
      </Loadable>
      <IconButton intent='link-grey' leadingIcon={<LinkExternalIcon className='size-4 text-quaternary-400' />} onClick={onAudienceClick} />
    </>
  );
};
